module.exports = __webpack_public_path__ + "img/about-b-slide.a566c169.jpg";